import React, { useEffect, useState } from "react";

const TabsPanel = (props) => {
  const [selected, setSelected] = useState(props.selected || 0);

  // Automatically change the selected tab every 5 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      setSelected((prevSelected) => {
        const nextSelected = prevSelected + 1;
        return nextSelected >= props.children.length ? 0 : nextSelected;
      });
    }, 3000); // Change every 3 seconds

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [props.children.length]);

  const renderTab = (index) => {
    setSelected(index);
  };

  const renderMenu = () => {
    const panels = props.children;
    return panels.map((elem, index) => {
      let selectedStyle = index === selected ? " selected" : "";
      let icon = elem.props.icon;
      let display = elem.props.hide;
      return display ? null : (
        <li
          key={index}
          className={"tab" + selectedStyle}
          onClick={() => renderTab(index)}
        >
          {icon ? icon : null}
          {window.innerWidth >= 700 ? (
            <span>
              {elem.props.title} - {elem.props.subtitle}
            </span>
          ) : (
            <span>{elem.props.title}</span>
          )}
        </li>
      );
    });
  };

  const getSubtitle = () => {
    const subtitle = props.children[selected].props.subtitle;
    if (!subtitle) return null;

    return <h2 className="subtitle">{subtitle}</h2>;
  };

  const getImage = () => {
    const image = props.children[selected].props.image;
    if (!image) return null;

    return <img className="mt-2" src={image} alt="" />;
  };

  return (
    <div className="d-flex">
      <ul className="tabs">{renderMenu()}</ul>
      <div className="tab__content">
        {getSubtitle()}
        {props.children[selected]}
        <div className="image-container">{getImage()}</div>
      </div>
    </div>
  );
};

export default TabsPanel;
